/**
 * User-facing message for failed form saves (Firestore / network).
 * Prefer this over silent catch or raw error codes.
 */
export function saveErrorMessage (error, fallback) {
  const raw = error && (error.message || error.code || String(error)) || ''
  const lower = raw.toLowerCase()
  if (
    lower.includes('permission') ||
    lower.includes('insufficient') ||
    (error && error.code === 'permission-denied')
  ) {
    return 'Could not save — your login email may not match this registration. Email hello@iabf.dance for help.'
  }
  if (lower.includes('network') || lower.includes('offline') || lower.includes('unavailable')) {
    return 'Network error — check your connection and try again.'
  }
  if (fallback) {
    return fallback
  }
  return 'Something went wrong. Please try again.'
}
